import React from 'react';
import { Button, Form, Icon, Section, Table } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import Styles from '../../../../../styles/form/modalAddFields.module.css';
import PropTypes from 'prop-types';

const { Tr: TableRow, Td: TableCell, TBody: TableBody } = Table;

export default function SelectFieldForm({ form, onChangeForm }) {
    const { t } = useTranslation();

    const [choices, setChoices] = React.useState(form.question_choices);
    const [currentChoice, setCurrentChoice] = React.useState(null);

    const onChangeCurrentChoice = React.useCallback(
        label => {
            setCurrentChoice({
                label: label,
                order: choices.length + 1
            });
        },
        [currentChoice]
    );

    const addChoice = React.useCallback(() => {
        let _choices = [...choices, currentChoice];
        setChoices(_choices);
        onChangeForm('question_choices', _choices);
        setCurrentChoice(null);
    }, [choices, currentChoice, onChangeForm]);

    const actualizeOrder = _choices => {
        let choicesTmp = [];
        _choices.forEach((value, index) => {
            choicesTmp.push({ ...value, ...{ order: index + 1 } });
        });
        return choicesTmp;
    };

    const dragAndDrop = React.useCallback(
        ({ oldIndex, newIndex }) => {
            let _choices = [...choices];
            let [choiceMoved] = _choices.splice(oldIndex, 1);
            _choices.splice(newIndex, 0, choiceMoved);
            _choices = actualizeOrder(_choices);
            setChoices(_choices);
            onChangeForm('question_choices', _choices);
        },
        [choices, onChangeForm]
    );

    const deleteChoice = React.useCallback(
        choiceToDelete => {
            // Ensure each choice has an order number
            const _choices = actualizeOrder(
                choices.map(choice => {
                    if (choice === choiceToDelete) return { ...choice, deleted: true };
                    return choice;
                })
            );
            setChoices(_choices);
            onChangeForm('question_choices', _choices);
        },
        [choices, onChangeForm]
    );

    return (
        <Section>
            <Form.Field>
                <Form.Label>{t('ticket.form.modal.customFields.answerLabel')}</Form.Label>
                <div className={Styles['select-field-form__add-container']}>
                    <Form.Input
                        value={currentChoice?.label || ''}
                        onChange={({ target: { value } }) => {
                            onChangeCurrentChoice(value);
                        }}
                    />
                    <Button
                        primary
                        className={Styles['select-field-form__add-button']}
                        disabled={!currentChoice || currentChoice?.label.length === 0}
                        onClick={addChoice}
                        label={t('ticket.common.action.add')}
                    />
                </div>
            </Form.Field>
            {choices.length > 0 && (
                <Table useNew draggable onSortEnd={event => dragAndDrop(event)} className={Styles['select-field-form__table']}>
                    <TableBody>
                        {choices
                            .filter(obj => obj.deleted !== true)
                            .map((choice, index) => (
                                <TableRow key={index} withHoverHighlightRow={false} onClick={false} className={Styles['select-field-form__table-row']}>
                                    <TableCell>{choice?.label}</TableCell>
                                    <TableCell className={Styles['select-field-form__cell-delete']}>
                                        <Icon name={'cross'} size={'small'} onClick={() => deleteChoice(choice)} />
                                    </TableCell>
                                </TableRow>
                            ))}
                    </TableBody>
                </Table>
            )}
        </Section>
    );
}

SelectFieldForm.propTypes = {
    form: PropTypes.object.isRequired,
    onChangeForm: PropTypes.func.isRequired
};
